"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDUCATION_DEFAULT_TABS_ORDER = exports.INSURANCE_DEFAULT_TABS_ORDER = exports.MFO_DEFAULT_TABS_ORDER = exports.BANK_DEFAULT_TABS_ORDER = exports.ORGANIZATION_CARD_DEFAULT_TABS_ORDER = exports.OFFERS_TABS_DEFAULT_ORDER = exports.OFFERS = exports.VITRINS_OFFERS_LIST = exports.OTHER_OFFERS_LIST = exports.BUSINESS_OFFERS_LIST = exports.EDUCATION_OFFERS_LIST = exports.LEARNING_TYPES_LIST = exports.INSURANCE_OFFERS_FROM_VITRINS_LIST = exports.INSURANCE_OFFERS_LIST = exports.ACTIONS_LIST = exports.COMMON_OFFERS_LIST = exports.OTHER_OFFERS = exports.BUSINESS_OFFERS = exports.EDUCATION_OFFERS = exports.LEARNING_TYPES = exports.INSURANCE_OFFERS_FROM_VITRINS = exports.INSURANCE_OFFERS = exports.ACTIONS = exports.COMMON_OFFERS = void 0;
const helpers_1 = require("./helpers");
exports.COMMON_OFFERS = {
    savings: 'savings',
    credits: 'credits',
    mortgage: 'mortgage',
    creditCards: 'creditCards',
    debitCards: 'debitCards',
    loan: 'loan',
    accumulative: 'accumulative',
    brokerskoeObsluzhivanie: 'brokerskoeObsluzhivanie',
    bankrotstvo: 'bankrotstvo',
};
exports.ACTIONS = {
    // none = 'none',
    osago: 'osago',
};
exports.INSURANCE_OFFERS = {
    insuranceOsago: 'insuranceOsago',
    dms: 'dms',
    'strahovka-kriticheskie-bolezni': 'strahovka-kriticheskie-bolezni',
    // 'strahovka-ot-klescha': 'strahovka-ot-klescha',
    'strahovanie-domov': 'strahovanie-domov',
};
exports.INSURANCE_OFFERS_FROM_VITRINS = {
    dms: 'dms',
    'strahovka-kriticheskie-bolezni': 'strahovka-kriticheskie-bolezni',
    // 'strahovka-ot-klescha': 'strahovka-ot-klescha',
    'strahovanie-domov': 'strahovanie-domov',
};
exports.LEARNING_TYPES = {
    typeProgramming: 'typeProgramming',
    typeAnalytics: 'typeAnalytics',
    typeMarketing: 'typeMarketing',
    typeDesign: 'typeDesign',
    typeManagement: 'typeManagement',
    typeAdmin: 'typeAdmin',
    typeFinance: 'typeFinance',
    typeLanguage: 'typeLanguage',
    typeCreativity: 'typeCreativity',
    typeSoftSkills: 'typeSoftSkills',
    typeApplication: 'typeApplication',
    typeBeauty: 'typeBeauty',
    typePO: 'typePO',
    typeSport: 'typeSport',
    typeDPO: 'typeDPO',
};
exports.EDUCATION_OFFERS = {
    learning: 'learning',
};
exports.BUSINESS_OFFERS = {
    biznesRko: 'biznesRko',
    biznesKredity: 'biznesKredity',
    biznesRegistration: 'biznesRegistration',
    biznesEkvajring: 'biznesEkvajring',
    biznesAccounting: 'biznesAccounting',
    bankovskieGarantii: 'bankovskieGarantii',
    // biznesDepozit: 'biznesDepozit',
    biznesMarketplace: 'biznesMarketplace',
    biznesLeasing: 'biznesLeasing',
    zarplatnyjProekt: 'zarplatnyjProekt',
    biznesVed: 'biznesVed',
};
exports.OTHER_OFFERS = {
    bukmekery: 'bukmekery',
};
exports.COMMON_OFFERS_LIST = (0, helpers_1.normalizeTabs)(Object.values(exports.COMMON_OFFERS));
exports.ACTIONS_LIST = (0, helpers_1.normalizeTabs)(Object.values(exports.ACTIONS));
exports.INSURANCE_OFFERS_LIST = (0, helpers_1.normalizeTabs)(Object.values(exports.INSURANCE_OFFERS));
exports.INSURANCE_OFFERS_FROM_VITRINS_LIST = (0, helpers_1.normalizeTabs)(Object.values(exports.INSURANCE_OFFERS_FROM_VITRINS));
exports.LEARNING_TYPES_LIST = Object.values(exports.LEARNING_TYPES);
exports.EDUCATION_OFFERS_LIST = Object.values(exports.EDUCATION_OFFERS).reduce((acc, type) => {
    if (type === exports.EDUCATION_OFFERS.learning) {
        const types = exports.LEARNING_TYPES_LIST.map(learningType => (0, helpers_1.makeTab)(type, learningType));
        return [...acc, ...types];
    }
    return [...acc, type];
}, []);
exports.BUSINESS_OFFERS_LIST = (0, helpers_1.normalizeTabs)(Object.values(exports.BUSINESS_OFFERS));
exports.OTHER_OFFERS_LIST = (0, helpers_1.normalizeTabs)(Object.values(exports.OTHER_OFFERS));
exports.VITRINS_OFFERS_LIST = [
    ...exports.COMMON_OFFERS_LIST,
    ...exports.INSURANCE_OFFERS_FROM_VITRINS_LIST,
    ...exports.EDUCATION_OFFERS_LIST,
    ...exports.BUSINESS_OFFERS_LIST,
    ...exports.OTHER_OFFERS_LIST,
];
exports.OFFERS = [
    ...exports.COMMON_OFFERS_LIST,
    ...exports.ACTIONS_LIST,
    ...exports.INSURANCE_OFFERS_LIST,
    ...exports.EDUCATION_OFFERS_LIST,
    ...exports.BUSINESS_OFFERS_LIST,
    ...exports.OTHER_OFFERS_LIST,
];
exports.OFFERS_TABS_DEFAULT_ORDER = (0, helpers_1.normalizeTabs)([
    exports.COMMON_OFFERS.loan,
    exports.COMMON_OFFERS.creditCards,
    exports.COMMON_OFFERS.savings,
    exports.COMMON_OFFERS.debitCards,
    exports.COMMON_OFFERS.credits,
    exports.COMMON_OFFERS.mortgage,
    exports.COMMON_OFFERS.brokerskoeObsluzhivanie,
    exports.BUSINESS_OFFERS.biznesRko,
    exports.COMMON_OFFERS.accumulative,
    exports.BUSINESS_OFFERS.biznesKredity,
    exports.COMMON_OFFERS.bankrotstvo,
    (0, helpers_1.makeTab)(exports.EDUCATION_OFFERS.learning, exports.LEARNING_TYPES.typeProgramming),
    ...exports.INSURANCE_OFFERS_LIST,
]);
exports.ORGANIZATION_CARD_DEFAULT_TABS_ORDER = (0, helpers_1.normalizeTabs)([
    exports.COMMON_OFFERS.credits,
    exports.COMMON_OFFERS.creditCards,
    exports.COMMON_OFFERS.savings,
    exports.COMMON_OFFERS.debitCards,
    exports.COMMON_OFFERS.mortgage,
    exports.BUSINESS_OFFERS.biznesRko,
    exports.COMMON_OFFERS.accumulative,
    exports.COMMON_OFFERS.brokerskoeObsluzhivanie,
    exports.COMMON_OFFERS.bankrotstvo,
    exports.BUSINESS_OFFERS.biznesKredity,
    ...exports.BUSINESS_OFFERS_LIST,
    ...exports.INSURANCE_OFFERS_FROM_VITRINS_LIST,
].reduce((acc, tab) => ((0, helpers_1.hasItem)(acc, tab) ? acc : [...acc, tab]), []));
exports.BANK_DEFAULT_TABS_ORDER = exports.OFFERS_TABS_DEFAULT_ORDER.reduce((acc, tab) => {
    return (0, helpers_1.hasItem)(acc, tab) ? acc : [...acc, tab];
}, [(0, helpers_1.makeTab)(exports.COMMON_OFFERS.creditCards)]);
exports.MFO_DEFAULT_TABS_ORDER = exports.OFFERS_TABS_DEFAULT_ORDER.reduce((acc, tab) => {
    return (0, helpers_1.hasItem)(acc, tab) ? acc : [...acc, tab];
}, [(0, helpers_1.makeTab)(exports.COMMON_OFFERS.loan)]);
exports.INSURANCE_DEFAULT_TABS_ORDER = exports.OFFERS_TABS_DEFAULT_ORDER.reduce((acc, tab) => {
    return (0, helpers_1.hasItem)(acc, tab) ? acc : [...acc, tab];
}, exports.INSURANCE_OFFERS_LIST);
exports.EDUCATION_DEFAULT_TABS_ORDER = exports.OFFERS_TABS_DEFAULT_ORDER.reduce((acc, tab) => {
    return (0, helpers_1.hasItem)(acc, tab) ? acc : [...acc, tab];
}, exports.EDUCATION_OFFERS_LIST);
